export default function PageHeader({ title, subtitle, children, overline }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6 animate-fade-up">
      <div>
        {overline && <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold-dark mb-1">{overline}</p>}
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tight text-burgundy leading-none">{title}</h1>
        {subtitle && <p className="text-sm text-[#7A7A7A] mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2 shrink-0">{children}</div>}
    </div>
  );
}
